import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaintMartin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_956)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9565 13.0435C10.9565 13.0435 3.52168 3.51305 3.51465 3.51473C5.68618 1.34316 8.68622 0 12 0C18.6273 0 24 5.37262 24 12L10.9565 13.0435Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9565 12C10.9565 12 3.52168 20.487 3.51465 20.4853C5.68618 22.6568 8.68622 24 12 24C18.6273 24 24 18.6274 24 12H10.9565Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51471 3.51469C-1.17157 8.20097 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51469Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.31534 12C1.30877 12.0862 1.30432 12.173 1.30432 12.2609C1.30432 14.1338 2.8227 15.6522 4.69563 15.6522C6.56857 15.6522 8.08694 14.1338 8.08694 12.2609C8.08694 12.173 8.08249 12.0862 8.07593 12H1.31534Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.69558 10.4348C5.27188 10.4348 5.73907 9.96761 5.73907 9.39131C5.73907 8.81501 5.27188 8.34782 4.69558 8.34782C4.11928 8.34782 3.6521 8.81501 3.6521 9.39131C3.6521 9.96761 4.11928 10.4348 4.69558 10.4348Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.34778 9.13045V12.5218C2.34778 14.3189 4.69561 14.8696 4.69561 14.8696C4.69561 14.8696 7.04343 14.3189 7.04343 12.5218V9.13045H2.34778Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.69675 13.7775C4.26119 13.6207 3.39124 13.2202 3.39124 12.5217V10.1739H5.99997V12.5217C5.99997 13.2225 5.13011 13.6221 4.69675 13.7775Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.21743 11.4783V10.9565L4.69571 10.6956L4.17395 10.9565V11.4783L3.91309 11.7391V12.7826H5.47834V11.7391L5.21743 11.4783Z",
				fill: "#F3F3F3"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_956",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSaintMartin;
